import React, { Component } from 'react'
import PropTypes from 'prop-types'
import TimeButton from './WhenTimeButton'

class WhenQuartersRow extends Component {

  filterBookings(no) {
    const date = this.datePlusQuarters(no)
    const {bookings} = this.props
    const t = bookings.filter(booking => {
      const dateStart = new Date(booking.dateStart)
      const dateEnd = new Date(booking.dateEnd)
      const test = dateStart.getTime() <= date.getTime() && dateEnd.getTime() > date.getTime()
      return test
    })
    return t
  }

  filterReservations(no) { // TODO: Merge with filterBookings, to avoid duplication
    const date = this.datePlusQuarters(no)
    const {reservations} = this.props
    const t = reservations.filter(reservation => {
      const dateStart = new Date(reservation.dateStart)
      const dateEnd = new Date(reservation.dateEnd)
      const test = dateStart.getTime() <= date.getTime() && dateEnd.getTime() > date.getTime()
      return test
    })
    return t
  }

  datePlusQuarters(no) {
    const {date} = this.props
    const quarterDate = new Date(date)
    quarterDate.setMinutes(no * 15)
    return quarterDate
  }

  render() {
    const { getKey, booking, selectedTimeChanged, capacity, amountPeople, addCapacityWarning } = this.props

    return (
      <div className="mt-2">
        <div className="flex mx-auto">
          {[0,1,2,3].map(i => (
            <TimeButton
              date={this.datePlusQuarters(i)}
              bookings={this.filterBookings(i)}
              reservations={this.filterReservations(i)}
              selectedTimeChanged={selectedTimeChanged}
              booking={booking}
              capacity={capacity}
              amountPeople={amountPeople}
              addCapacityWarning={addCapacityWarning}
              key={getKey()}
              getKey={getKey}
            />
          ))}
        </div>
      </div>
    )
  }
}

WhenQuartersRow.propTypes = {
  booking: PropTypes.shape({booking: PropTypes.object}).isRequired,
  date: PropTypes.instanceOf(Date).isRequired,
  bookings: PropTypes.instanceOf(Array).isRequired,
  reservations: PropTypes.instanceOf(Array).isRequired,
  selectedTimeChanged: PropTypes.func.isRequired,
  capacity: PropTypes.number.isRequired,
  amountPeople: PropTypes.number.isRequired,
  addCapacityWarning: PropTypes.func.isRequired,
  getKey: PropTypes.func.isRequired
}

WhenQuartersRow.defaultProps = {}

export default WhenQuartersRow